import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { NotificationService } from './../../services/notification.service';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { LoginService } from '../../services/login.service';
import { CommonDataSharedService } from 'app/services';


@Component({
  selector: 'app-account-settings',
  templateUrl: './account-settings.component.html',
  styleUrls: ['./account-settings.component.scss']
})
export class AccountSettingsComponent implements OnInit {
  userRole: string;
  userData: any;
  username: string;
  avatarUrl: string;
  inputJson;
  newUsername: string;
  confirmUsername: string;
  password: string;
  newPassword: string;
  confirmPassword: string;
  hide: Function;
  uploadAvatarFlag: boolean;
  fileArray: any = '';
  showAvatar = false;
  isAvatarDeleted = false;



  constructor(
    private notificationService: NotificationService,
    private loginService: LoginService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private _commonDataSharedService: CommonDataSharedService
  ) { }

  ngOnInit() {
    const localStorageData = JSON.parse(localStorage.getItem('loginUserData'));
    this.avatarUrl = localStorageData.fileUrl;
    this.showAvatar = !['Parent', 'student'].includes(localStorageData.module);

  }

  accountUpdate(form: NgForm) {
    const localStorageData = JSON.parse(localStorage.getItem('loginUserData'));
    if ((form.value.newUsername || form.value.newPassword || this.fileArray || this.isAvatarDeleted)) {
      this.inputJson = {
        password: form.value.password,
        token: localStorageData.token
      };
      if (form.value.newUsername && form.controls.newUsername.valid && form.value.confirmUsername === form.value.newUsername) {
        this.inputJson['Username'] = form.value.newUsername
      } else {
        if (form.value.newUsername && !form.controls.newUsername.valid) {
          this.notificationService.show('error', 'Username should be valid');
          return
        }
        if (form.value.confirmUsername !== form.value.newUsername) {
          this.notificationService.show('error', `Username & confirmation doesn't match`);
          return
        }
      }

      if (form.value.newPassword && form.controls.newPassword.valid && form.value.newPassword === form.value.confirmPassword) {
        this.inputJson['NewPassword'] = form.value.newPassword;
      } else {
        if (form.value.newPassword && !form.controls.newPassword.valid) {
          this.notificationService.show('error', 'Password should be valid');
          return
        }
        if (form.value.newPassword !== form.value.confirmPassword) {
          this.notificationService.show('error', `New password & confirmation doesn't match`);
          return
        }
      }

      if (this.fileArray) {
        this.inputJson['avatarUrl'] = this.fileArray.toString()
        this.inputJson['changeAvatar'] = true;
      }
      if (this.isAvatarDeleted) {
        this.inputJson['deleteAvatar'] = true;
        this.inputJson['changeAvatar'] = true;
      }
      this._commonRequestResponseService.post('shared/update/usernamepassword', this.inputJson)
        .subscribe(
          (data) => {

            this.hide();
            if (this.inputJson['avatarUrl']) {
              this._commonDataSharedService.avatarUpdate.next(data['avatarUrl']);
            }
            if (this.isAvatarDeleted) {
              this._commonDataSharedService.avatarUpdate.next(this.avatarUrl);
            }
            if ((this.inputJson['Username'] || this.inputJson['NewPassword'])) {
              this.loginService.logout();
            }
            this.isAvatarDeleted = false;
            this.notificationService.show('success', 'Updated user data successfully');
          },
          error => {
            this.notificationService.show('error', error.errorMessage || 'Error while updating user data');
          })
    } else {
        this.notificationService.show('error', 'Please enter data to update');
    }

  }



  fileChangeEvent(fileInput) {
    const reader = new FileReader();
    const readerByte = new FileReader();
    reader.readAsDataURL(fileInput.target.files[0]);
    reader.onload = () => this.avatarUrl = reader.result as any;
    readerByte.onload = () => {
      this.fileArray = new Uint8Array(readerByte.result as any);
    };
    readerByte.readAsArrayBuffer(fileInput.target.files[0]);
  }

  onCancel() {
    this.hide();
  }


  deleteStudentProfileImage() {
    this.isAvatarDeleted = true;
    this.avatarUrl = '';
  }
}
